<aside id="sidebar" class="sidebar">
  <div class="sidebar-client" *ngIf="logoCuenta">
    @if (logoCuenta) {
      <img class="logo-cliente" [src]="logoCuenta" alt="Logo del cliente" (error)="logoCuenta = undefined" />
    }
  </div>
  <ul class="sidebar-nav" id="sidebar-nav">
    @for (menu of menus; track menu) {
      <ng-container>
        @if (!menu.esAgrupador && !!menu.link) {
          <li class="nav-item">
            <a class="nav-link collapsed" routerLinkActive="active" ariaCurrentWhenActive="page" [routerLinkActiveOptions]="{ exact: true }" [routerLink]="menu.link">
              <i [class]="menu.icono"></i> <span>{{ menu.nombre }}</span>
            </a>
          </li>
        }
        @if (menu.esAgrupador && !menu.icono) {
          <li class="nav-heading">{{ menu.nombre }}</li>
          <hr class="p-0 m-0" />
          @if ((menu?.subMenus?.length ?? 0) !== 0) {
            <ng-container>
              @for (subMenuNivel1 of menu.subMenus; track subMenuNivel1) {
                <li class="nav-item">
                  @if ((subMenuNivel1?.subMenus?.length ?? 0) === 0) {
                    <a class="nav-link collapsed" routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="subMenuNivel1.link"
                      ><i [class]="subMenuNivel1.icono"></i><span>{{ subMenuNivel1.nombre }}</span></a
                    >
                  }
                  @if ((subMenuNivel1?.subMenus?.length ?? 0) !== 0) {
                    <a
                      class="nav-link collapsed"
                      [attr.data-bs-target]="'#operaciones-' + obtenerTituloModulo(subMenuNivel1.nombre) + '-nav'"
                      data-bs-toggle="collapse"
                    >
                      <i [class]="subMenuNivel1.icono"></i><span>{{ subMenuNivel1.nombre }}</span
                      ><i class="bi bi-chevron-down ms-auto"></i>
                    </a>
                    <ul
                      [id]="'operaciones-' + obtenerTituloModulo(subMenuNivel1.nombre) + '-nav'"
                      class="nav-content collapse"
                      data-bs-parent="#sidebar-nav"
                    >
                      @for (subMenuNivel2 of subMenuNivel1.subMenus; track subMenuNivel2) {
                        <ng-container>
                          @if (subMenuNivel2.esEncabezado) {
                            <li class="nav-heading">{{ subMenuNivel2.nombre }}</li>
                            @for (subMenuNivel2Encabezado of subMenuNivel2.subMenus; track subMenuNivel2Encabezado) {
                              <li>
                                <a routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="subMenuNivel2Encabezado.link">
                                  <i [class]="subMenuNivel2Encabezado.icono"></i
                                  ><span>{{ subMenuNivel2Encabezado.nombre }}</span>
                                </a>
                              </li>
                            }
                          }
                          @if (!subMenuNivel2.esEncabezado) {
                            <li>
                              <a routerLinkActive="active" ariaCurrentWhenActive="page" [routerLink]="subMenuNivel2.link">
                                <i [class]="subMenuNivel2.icono"></i><span>{{ subMenuNivel2.nombre }}</span>
                              </a>
                            </li>
                          }
                        </ng-container>
                      }
                    </ul>
                  }
                </li>
              }
            </ng-container>
          }
        }
      </ng-container>
    }
  </ul>
</aside>
